import httpClient from "./httpClient";

const getIntroduction = () => httpClient.get("/Introduction/Facility/Get?page=1&pageSize=1000").then(
  (response) => {return response}
)

const  setIntroduction = (params) => httpClient.post("/Introduction/Facility/Post",params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const putIntroduction = (params,id) => httpClient.put(`/Introduction/Facility/Put/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

const deleteIntroduction = (id) => httpClient.delete(`/Introduction/Facility/Delete/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })



export {
  getIntroduction ,
  setIntroduction,
  putIntroduction,
  deleteIntroduction
}
